interface State {
    appToast: AppToast
}

export interface AppToast {
    text: string
    visible: boolean
}

const defaults = () => {
    return {
        appToast: {
            text: null,
            visible: false
        }
    }
}

export default {
    state: defaults(),
    mutations: {
        appToastReset (state: State): void {
            Object.assign(state, defaults())
        },
        appToastSet (state: State, obj: AppToast): void {
            //  Set our toast to our object
            state.appToast = obj

            //  Check if the object has a visible prop
            const visible = obj.visible

            //  If it is NOT visible then do nothing
            if (!visible) return

            //  Else, we should hide this after 2 seconds
            setTimeout(() => {
                state.appToast.visible = false
            }, 2000)
        },
    },
    getters: {
        appToast (state: State): AppToast {
            return state.appToast
        }
    }
}
